import type { Cases } from 'petrovich';

export type MorphCase = Cases;

export const POSITION_MORPH_DICTIONARY: Record<string, Partial<Record<MorphCase, string>>> = {
  'индивидуальный предприниматель': {
    nominative: 'Индивидуальный предприниматель',
    genitive: 'Индивидуального предпринимателя',
    dative: 'Индивидуальному предпринимателю',
    accusative: 'Индивидуального предпринимателя',
    instrumental: 'Индивидуальным предпринимателем',
    prepositional: 'Индивидуальном предпринимателе',
  },
  'главный бухгалтер': {
    nominative: 'Главный бухгалтер',
    genitive: 'Главного бухгалтера',
    dative: 'Главному бухгалтеру',
    accusative: 'Главного бухгалтера',
    instrumental: 'Главным бухгалтером',
    prepositional: 'Главном бухгалтере',
  },
  'генеральный директор': {
    nominative: 'Генеральный директор',
    genitive: 'Генерального директора',
    dative: 'Генеральному директору',
    accusative: 'Генерального директора',
    instrumental: 'Генеральным директором',
    prepositional: 'Генеральном директоре',
  },
  'коммерческий директор': {
    nominative: 'Коммерческий директор',
    genitive: 'Коммерческого директора',
    dative: 'Коммерческому директору',
    accusative: 'Коммерческого директора',
    instrumental: 'Коммерческим директором',
    prepositional: 'Коммерческом директоре',
  },
  'финансовый директор': {
    nominative: 'Финансовый директор',
    genitive: 'Финансового директора',
    dative: 'Финансовому директору',
    accusative: 'Финансового директора',
    instrumental: 'Финансовым директором',
    prepositional: 'Финансовом директоре',
  },
  'исполнительный директор': {
    nominative: 'Исполнительный директор',
    genitive: 'Исполнительного директора',
    dative: 'Исполнительному директору',
    accusative: 'Исполнительного директора',
    instrumental: 'Исполнительным директором',
    prepositional: 'Исполнительном директоре',
  },
  'директор': {
    nominative: 'Директор',
    genitive: 'Директора',
    dative: 'Директору',
    accusative: 'Директора',
    instrumental: 'Директором',
    prepositional: 'Директоре',
  },
  'заместитель генерального директора': {
    nominative: 'Заместитель генерального директора',
    genitive: 'Заместителя генерального директора',
    dative: 'Заместителю генерального директора',
    accusative: 'Заместителя генерального директора',
    instrumental: 'Заместителем генерального директора',
    prepositional: 'Заместителе генерального директора',
  },
  'заместитель директора': {
    nominative: 'Заместитель директора',
    genitive: 'Заместителя директора',
    dative: 'Заместителю директора',
    accusative: 'Заместителя директора',
    instrumental: 'Заместителем директора',
    prepositional: 'Заместителе директора',
  },
  'руководитель': {
    nominative: 'Руководитель',
    genitive: 'Руководителя',
    dative: 'Руководителю',
    accusative: 'Руководителя',
    instrumental: 'Руководителем',
    prepositional: 'Руководителе',
  },
  'начальник': {
    nominative: 'Начальник',
    genitive: 'Начальника',
    dative: 'Начальнику',
    accusative: 'Начальника',
    instrumental: 'Начальником',
    prepositional: 'Начальнике',
  },
};
